import axios from 'axios'
import * as types from '../mutation-types'

import { createTheParametersOfTheUrl } from '../../plugins/helper'

const doToArrayObject = (data) => {
  const arr = []
  let i = 0
  for (i in data) {
    if (data.hasOwnProperty(i)) {
      arr.push({
        value: data[i].id,
        text: data[i].lote,
        disabled: data[i].activo,
      })
    }
  }

  return arr
}

const doToArrayObjectWithoutDisabled = (data) => {
  const arr = []
  let i = 0
  for (i in data) {
    if (data.hasOwnProperty(i)) {
      arr.push({
        value: data[i].id,
        text: data[i].lote,
      })
    }
  }

  return arr
}

// state
export const state = {
  loadingLotes: true,
  lotes: [],
  errorLotes: null,
  loadingLotesSelection: true,
  lotesSelection: [],
  errorLotesSelection: null,
  loadingLotesSelectionAll: true,
  lotesSelectionAll: [],
  errorLotesSelectionAll: null,
  loadingLotsByPreContract: true,
  lotsByPreContract: [],
  errorLotsByPreContract: null,
}

// mutations
export const mutations = {
  [types.GET_LOTES_START](state) {
    state.loadingLotes = true
    state.lotes = []
    state.errorLotes = null
  },

  [types.GET_LOTES_SUCCESS](state, data) {
    state.loadingLotes = false
    state.lotes = data
    state.errorLotes = null
  },

  [types.GET_LOTES_ERROR](state, { error }) {
    state.loadingLotes = false
    state.lotes = []
    state.errorLotes = error
  },

  [types.GET_LOTES_SELECTION_START](state) {
    state.loadingLotesSelection = true
    state.lotesSelection = []
    state.errorLotesSelection = null
  },

  [types.GET_LOTES_SELECTION_SUCCESS](state, { data }) {
    state.loadingLotesSelection = false
    state.lotesSelection = doToArrayObject(data)
    state.errorLotesSelection = null
  },

  [types.GET_LOTES_SELECTION_ERROR](state, { error }) {
    state.loadingLotesSelection = false
    state.lotesSelection = []
    state.errorLotesSelection = error
  },

  [types.GET_LOTES_SELECTION_ALL_START](state) {
    state.loadingLotesSelectionAll = true
    state.lotesSelectionAll = []
    state.errorLotesSelectionAll = null
  },

  [types.GET_LOTES_SELECTION_ALL_SUCCESS](state, { data }) {
    state.loadingLotesSelectionAll = false
    state.lotesSelectionAll = doToArrayObjectWithoutDisabled(data)
    state.errorLotesSelectionAll = null
  },

  [types.GET_LOTES_SELECTION_ALL_ERROR](state, { error }) {
    state.loadingLotesSelectionAll = false
    state.lotesSelectionAll = []
    state.errorLotesSelectionAll = error
  },

  [types.GET_LOTS_BY_PRECONTRACT_START](state) {
    state.loadingLotsByPreContract = true
    state.lotsByPreContract = []
    state.errorLotsByPreContract = null
  },

  [types.GET_LOTS_BY_PRECONTRACT_SUCCESS](state, { data }) {
    state.loadingLotsByPreContract = false
    state.lotsByPreContract = data
    state.errorLotsByPreContract = null
  },

  [types.GET_LOTS_BY_PRECONTRACT_ERROR](state, { error }) {
    state.loadingLotsByPreContract = false
    state.lotsByPreContract = []
    state.errorLotsByPreContract = error
  },
}

export const actions = {
  async getLotes({ commit }, payload) {
    try {
      commit(types.GET_LOTES_START)

      const href = createTheParametersOfTheUrl(payload)
      const { data } = await axios.get(`/api/lotes${href}`)

      commit(types.GET_LOTES_SUCCESS, { data })
    } catch (e) {
      commit(types.GET_LOTES_ERROR, { error: null })
    }
  },

  async getLotsSelection({ commit }, payload) {
    try {
      commit(types.GET_LOTES_SELECTION_START)

      const href = createTheParametersOfTheUrl(payload)
      const { data } = await axios.get(`/api/lotes/list${href}`)

      commit(types.GET_LOTES_SELECTION_SUCCESS, { data })
    } catch (e) {
      commit(types.GET_LOTES_SELECTION_ERROR, { error: null })
    }
  },

  async getLotsSelectionAll({ commit }, payload) {
    try {
      commit(types.GET_LOTES_SELECTION_ALL_START)

      const href = createTheParametersOfTheUrl(payload)
      const { data } = await axios.get(`/api/lotes/list${href}`)

      commit(types.GET_LOTES_SELECTION_ALL_SUCCESS, { data })
    } catch (e) {
      commit(types.GET_LOTES_SELECTION_ALL_ERROR, { error: null })
    }
  },

  async getLotsByPreContract({ commit }, payload, idPreContract) {
    try {
      commit(types.GET_LOTS_BY_PRECONTRACT_START)

      const href = createTheParametersOfTheUrl(payload)
      const { data } = await axios.get(`/api/sale/precontracts/${idPreContract}/lotes${href}`)

      commit(types.GET_LOTS_BY_PRECONTRACT_SUCCESS, { data })
    } catch (e) {
      commit(types.GET_LOTS_BY_PRECONTRACT_ERROR, { error: e })
    }
  },
}

// getters
export const getters = {
  loadingLotes: state => state.loadingLotes,
  lotes: state => state.lotes,
  errorLotes: state => state.errorLotes,
  loadingLotesSelection: state => state.loadingLotesSelection,
  lotesSelection: state => state.lotesSelection,
  errorLotesSelection: state => state.errorLotesSelection,
  loadingLotesSelectionAll: state => state.loadingLotesSelectionAll,
  lotesSelectionAll: state => state.lotesSelectionAll,
  errorLotesSelectionAll: state => state.errorLotesSelectionAll,
  loadingLotsByPreContract: state => state.loadingLotsByPreContract,
  lotsByPreContract: state => state.lotsByPreContract,
  errorLotsByPreContract: state => state.errorLotsByPreContract,
}
